module.exports = "pegasus/assets/blocks/image-4-theme2.png";